module.exports = __webpack_public_path__ + "static/media/Scorecard_active.4e315278.svg";